// MOD-17 Component Studio — wire DTO'ları (generated) + garanti alanlı FE tipleri.
//
// Config-tier üç-durum yayın (Draft/Published/Archived); versiyonlu (generic
// ContentVersion altyapısı). Şablon dil-nötr (i18n YOK) — dil içeriği sayfadaki
// prop değerlerindedir. `blockKey = cmp_{Id:N}` = Puck runtime blok anahtarı.

import type { components } from '@/types/api';
import type { PropType } from './constants';

/** Wire DTO'ları (generated openapi tipleri). */
export type ComponentDefinitionDtoWire = components['schemas']['ComponentDefinitionDto'];
export type ComponentListItemDtoWire = components['schemas']['ComponentListItemDto'];
export type ComponentPaletteItemDtoWire = components['schemas']['ComponentPaletteItemDto'];
export type ComponentVersionDtoWire = components['schemas']['ComponentVersionDto'];
export type CreateComponentRequest = components['schemas']['CreateComponentRequest'];
export type UpdateComponentRequest = components['schemas']['UpdateComponentRequest'];

/** Config-tier üç-durum yayın durumu (BE `ComponentStatus`). */
export type ComponentStatus = 'Draft' | 'Published' | 'Archived';

export function normalizeComponentStatus(status: string | null | undefined): ComponentStatus {
  if (status === 'Published') return 'Published';
  if (status === 'Archived') return 'Archived';
  return 'Draft';
}

/** Şema tasarımcısının tek prop modeli — client-only `id` serialize edilmez. */
export interface PropFieldModel {
  /** UI reconciliation için istikrarlı client id (BE'ye gitmez). */
  id: string;
  key: string;
  type: PropType;
  label: string;
  required: boolean;
  /** Yalnız `select` için anlamlı; diğer tiplerde boş bırakılır. */
  options: string[];
  /** Örnek/varsayılan değer — string olarak tutulur, serialize'da tipe göre yorumlanır. */
  default: string;
}

/** Liste satırı. */
export interface ComponentListItem {
  id: string;
  name: string;
  category: string;
  status: ComponentStatus;
  blockKey: string;
  updatedAt: string;
}

/** Tam bileşen tanımı (editör draft'ının kaynağı). */
export interface ComponentDetail {
  id: string;
  name: string;
  category: string;
  propsSchemaJson: string;
  templateHtml: string;
  /** FAZ-10 / K-18 — Puck iç modeli (BE sözleşmesi `{root:{},content:[]}`); yoksa legacy. */
  componentJson: string;
  defaultStyleJson: string;
  status: ComponentStatus;
  blockKey: string;
  updatedAt: string;
}

/** Palet öğesi (published-only) — Puck runtime bileşen üretimi bunu tüketir. */
export interface ComponentPaletteItem {
  id: string;
  blockKey: string;
  name: string;
  category: string;
  propsSchemaJson: string;
  templateHtml: string;
  componentJson: string;
  defaultStyleJson: string;
}

/** Versiyon kaydı. */
export interface ComponentVersion {
  id: string;
  componentId: string;
  versionNumber: number;
  name: string;
  changeNote: string;
  authorEmail: string;
  templateHtml: string;
  /** FAZ-10 / K-24 — eski satırlarda boş; diff pretty-JSON'u bundan üretilir. */
  componentJson: string;
  createdAt: string;
}

export interface ComponentCreateInput {
  name: string;
  category?: string;
  /** BE kuralı: create en az bir kaynak taşımalı (template VEYA componentJson). */
  componentJson?: string;
}

export interface ComponentUpdateInput {
  name: string;
  category: string;
  propsSchemaJson: string;
  /** K-20 — legacy fallback; editörde DEĞİŞTİRİLMEZ (mevcut değer geri gönderilir). */
  templateHtml: string;
  /** FAZ-10 / K-18 — Puck iç modeli; yeni kaynak-hakikat. */
  componentJson: string;
  defaultStyleJson?: string;
  changeNote?: string;
}

export interface ComponentListQuery {
  category?: string;
  status?: ComponentStatus;
}

/**
 * FAZ-10.6 / K-36 — bir bileşeni kullanan sayfa (cmp_ bloğu taşıyan). Wire tipi
 * generated openapi'de HENÜZ olmayabilir (BE B-son eklerken); manuel-wire edilir,
 * uç 404 ise editör paneli gizli-degrade eder.
 */
export interface ComponentUsage {
  pageId: string;
  title: string;
  status: string;
}
